module.exports = __webpack_public_path__ + "static/img/gaozhongzhengzhi.b15e1209.jpg";